import { render, staticRenderFns } from "./AllRecipesList.vue?vue&type=template&id=2d4efaae&scoped=true"
import script from "./AllRecipesList.vue?vue&type=script&lang=js"
export * from "./AllRecipesList.vue?vue&type=script&lang=js"
import style0 from "./AllRecipesList.vue?vue&type=style&index=0&id=2d4efaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4efaae",
  null
  
)

export default component.exports